import React, { useState, useEffect } from "react";
import { Carousel, Typography, Skeleton } from "antd";
import loginMockupAM from "./../../media/prequest-am-mockup.png";
import { useTranslation } from "react-i18next";
import PlaceHolderContent from "./PlaceHolderContent";

const { Title } = Typography;

export default function PlaceHolder() {
  const isLoading = useLoadingFinished();
  const { t } = useTranslation(["login"]);

  if (isLoading) {
    return <Skeleton title={false} paragraph={{ rows: 1 }} />;
  }

  return (
    <Carousel autoplay autoplaySpeed={5000} speed={1000}>
      <PlaceHolderContent
        title="Beheer al je assets vanuit één centrale plek"
        // description="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc feugiat diam ut nulla consectetur interdum. Nunc ac lacinia lorem. Nunc vel luctus lacus."
        imgSrc={loginMockupAM}
        imgAlt="img alt"
        buttonUrl="prequest.nl"
      />
    </Carousel>
  );

  function getSpaceManagementCarousel() {
    return (
      <div className="login-bg-image">
        <div className="login-content">
          <img
            className="login-content-image"
            src={loginMockupAM}
            alt="Login Mockup Space Management"
          />
          <div className="login-content-text">
            <Title level={2}>{t("spaceManagementPlaceHolder.title")}</Title>
            <p
              className="login-content-description"
              style={{ fontSize: "24px", color: "rgba(255,255,255,0.8" }}
            >
              {t("spaceManagementPlaceHolder.description")}
            </p>
          </div>
        </div>
      </div>
    );
  }

  function useLoadingFinished() {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
      setIsLoading(false);
    }, []);

    return isLoading;
  }
}
